export const urls = {
  GET_RADNE_NALOGE: 'DokRNPustanjeURad/rn_pustanje_u_rad_pregled_sa_filterom',
  GET_RADNE_NALOGE_FILTER:
    'DokRNPustanjeURad/rn_pustanje_u_rad_pregled_sa_filterom',
  GET_STATUSI_COMBO: 'Combo/vrati_statuse_dok_rn_pustanje_u_rad',
  DELETE_RADNI_NALOG: 'DokRNPustanjeURad/dokRNPustanjeURad_brisanje',
};
